<template>
    <div>

        <b-nav-item-dropdown 
            :disabled="$currentUserInfo.is_internal"
            right 
            menu-class="shadow" 
            toggle-class="no-outline"
        >
            <template v-slot:button-content>
                <b-icon icon="person-circle" font-scale="1.5"></b-icon>
                <span class="mx-2">{{ $currentUserInfo.user_full_name }}</span>
            </template>
            <!-- <b-dropdown-item href="#">
                <b-icon icon="person-lines-fill" variant="primary" class="mr-2"></b-icon>
                Profile
            </b-dropdown-item> -->
            <b-dropdown-item @click="$beacon('toggle')">
                <b-icon icon="question-circle" variant="info" class="mr-2"></b-icon>
                {{ $t('userDropdownMessages.support') }}
            </b-dropdown-item>
            <b-dropdown-item v-if="isAuthenticated" @click="startLogout">
                <b-icon icon="box-arrow-right" variant="danger" class="mr-2"></b-icon>
                {{ $t('userDropdownMessages.signOut') }}
            </b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item v-if="isAuthenticated" :href="splUrlMap.user_profile">
                <b-icon icon="person-lines-fill" variant="primary" class="mr-2"></b-icon>
                {{ $t('userDropdownMessages.account') }}
            </b-dropdown-item>
            <b-dropdown-divider v-if="languageSwitcherEnabled"></b-dropdown-divider>
            <b-dropdown-item v-if="languageSwitcherEnabled" link-class="d-flex align-items-center" @click="openLanguageSwitcher">
                <b-icon icon="translate" variant="primary" class="mr-2"></b-icon>
                <div class="d-inline-block text-left ml-1">
                    <div class="font-weight-500 text-black">{{ currentLanguageLabel }}</div>
                    <div class="special-text text-muted font-size-70">{{ $t('userDropdownMessages.clickToChange') }}</div>
                </div>
            </b-dropdown-item>
        </b-nav-item-dropdown>

        <logout-confirm
            ref="logoutConfirm"
        ></logout-confirm>
        <language-switcher-modal
            ref="languageSwitcherModal"
        ></language-switcher-modal>
    </div>
</template>

<script>
import { currentUserInfoMixin, splUrlMapMixin } from '../../js/custom-vue-mixins';
import LanguageSwitcherModal from '../shared/LanguageSwitcherModal.vue';
import { userDropdownMessages } from '@/localization/shared/userDropdown';

export default {
    name: 'PortalUserDropdown',
    components: {
        LanguageSwitcherModal,
    },
    mixins: [
        currentUserInfoMixin,
        splUrlMapMixin,
    ],
    i18n: {
        messages: userDropdownMessages,
    },
    props: {
        
    },
    data: function() {
        return {
            errorMsg: 'Error',
            error: false,
        }
    },
    computed: {
        isAuthenticated: function() {
            return !!this.$currentUserInfo.user_id;
        },
        languageSwitcherEnabled: function() {
            return !!this.$i18nData.enabled;
        },
        currentLanguageLabel: function() {
            return this.$i18nData.lang_info.name_translated || '';
        },
    },
    methods: {
        handleError: function(error, message) {
            console.log(message);
            console.log(error);
            this.errorMsg = message;
            this.error = true;
        },
        startLogout: function() {
            // call logout() method on component, which will show the confirm modal
            this.$refs.logoutConfirm.logout()
        },
        showBeacon: function() {
            const beacon = window.Beacon;
            if (beacon) {
                beacon('toggle');
            }
        },
        openLanguageSwitcher: function() {
            this.$refs.languageSwitcherModal.show()
        },
    }
}
</script>

<style>

</style>